import { createGlobalStyle, css } from 'styled-components'

const GlobalStyle = createGlobalStyle`${css`
  /* Third Party CSS */
  #ccs-inline {
    h1,
    h2,
    h3,
    h4 {
      text-transform: uppercase;
      font-weight: 600;
    }
    h2 {
      font-size: 28px;
      text-align: center;
    }
  }

  #klarna-messaging-pdp::part(osm-container) {
    border: 0px;
    padding: 0px;
    font-family: Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #2c2e2f;
  }
  #klarna-messaging-pdp::part(osm-cta) {
    color: #016fba; // Matching Paypal widget which is uncustomisable, Will be replaced with theme token when we move all to our own payment component.
    font-family: Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
  }
  #klarna-messaging-pdp::part(osm-message) {
    font-weight: 400;
    font-family: Helvetica, Arial, sans-serif;
    white-space: normal;
  }
  #klarna-messaging-pdp::part(osm-legal) {
    display: none;
  }

  /* GoInStore - Brand styling - enabled via javascript */
  /* LG GoInStore styling */
  /* Widget */
  #gis-cta-container {
    z-index: 80;
  }

  .gis-enable-product-brand-lg {
    #gis-awareness-msg-container {
      background-color: #fff;
      border-color: #fff;
      border-width: 2px;
      border-radius: 10px;
      box-shadow: 0 -3px 6px 0 rgba(51, 51, 51, 0.2), 0 4px 4px 0 rgba(0, 0, 0, 0.25);
      font-family: Barlow, 'Helvetica Neue', Helvetica, Arial, sans-serif;

      div:first-child {
        font-size: 16px;
        color: #262626;
      }

      div:last-child {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
        color: #1976d2 !important;
        text-decoration: underline;

        &::after {
          position: relative;
          width: 52px;
          height: 24px;
          margin-right: 12px;
          background-color: transparent;
          background-image: url('//media.4rgos.it/i/Argos/go-instore-lg-logo_1?h=24');
          background-repeat: no-repeat;
          background-position: 0 0;
          content: '';
        }
      }
      #gis-cta-awareness-close {
        svg {
          .cls-1 {
            fill: #ffffff !important;
          }
          polygon {
            color: #000 !important;
          }
        }
      }
    }
    #gis-cta {
      border-color: #333 !important;
      box-shadow: #333 0 0 0 0 !important;
      .gis-cta-indicator.available {
        background: #4dd865;
        border-color: #4dd865;
      }
    }
    /* Modal */
    #gis-v3-button {
      background: #008844;
    }
    #gis-connectv3-footer {
      display: block;
      a {
        color: #1976d2;
      }
    }
  }
  /* Samsung GoInStore styling */
  .gis-enable-product-brand-samsung {
    #gis-awareness-msg-container {
      background-color: #1428a0;
      border-color: #1428a0;
      border-width: 2px;
      border-radius: 10px;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25), 0 -3px 6px rgba(51, 51, 51, 0.2);

      div:first-child {
        color: #fff;
      }

      div:last-child {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        color: #fff !important;

        &::after {
          position: relative;
          color: #fff;
          content: 'SAMSUNG';
        }
      }

      #gis-cta-awareness-close {
        svg {
          .cls-1 {
            fill: #ffffff !important;
          }

          polygon {
            color: #000 !important;
          }
        }
      }
    }

    #gis-cta {
      border-color: #1428a0 !important;
      box-shadow: #1428a0 0 0 0 0 !important;

      .gis-cta-indicator.available {
        background: #4dd865;
        border-color: #4dd865;
      }
    }
  }

  /* Microsoft GoInStore styling */
  .gis-enable-product-brand-microsoft {
    #gis-awareness-msg-container {
      background-color: #000;
      border-color: #000;
      border-width: 2px;
      border-radius: 10px;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25), 0 -3px 6px rgba(51, 51, 51, 0.2);

      div:first-child {
        color: #fff;
      }

      div:last-child {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        color: #fff !important;

        &::after {
          position: relative;
          color: #fff;
          content: 'Microsoft';
        }
      }

      #gis-cta-awareness-close {
        svg {
          .cls-1 {
            fill: #ffffff !important;
          }

          polygon {
            color: #000 !important;
          }
        }
      }
    }

    #gis-cta {
      border-color: #333 !important;
      box-shadow: #333 0 0 0 0 !important;

      .gis-cta-indicator.available {
        background: #4dd865;
        border-color: #4dd865;
      }
    }
  }

  /* HP GoInStore styling */
  .gis-enable-product-brand-hp {
    #gis-awareness-msg-container {
      background-color: #0096d6;
      border-color: #0096d6;
      border-width: 2px;
      border-radius: 10px;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25), 0 -3px 6px rgba(51, 51, 51, 0.2);

      div:first-child {
        color: #fff;
      }

      div:last-child {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        color: #fff !important;

        &::after {
          position: relative;
          color: #fff;
          content: 'HP';
        }
      }

      #gis-cta-awareness-close {
        svg {
          .cls-1 {
            fill: #ffffff !important;
          }

          polygon {
            color: #000 !important;
          }
        }
      }
    }

    #gis-cta {
      border-color: #0096d6 !important;
      box-shadow: #0096d6 0 0 0 0 !important;

      .gis-cta-indicator.available {
        background: #4dd865;
        border-color: #4dd865;
      }
    }
  }
  /* End of Third Party CSS */

  .top-border {
    border-top: 1px solid ${props => props.theme.color.monochrome.light};
    padding-top: 10px;
    margin-top: 10px;
  }
  /* // Temporary accordion overrides */
  .pdp-accordions {
    clear: both;
    &.accordion-container {
      border-top: 1px solid ${props => props.theme.color.monochrome.light};
      margin-bottom: 40px;
    }
  }
  /* // End of accordion overrides */
  .pdp-pricing-module {
    margin-bottom: 30px;
  }
  .pdp-body {
    background-color: ${props => props.theme.color.monochrome.white};
    #app {
      overflow-x: hidden;
    }
    .prop-bar {
      margin-bottom: 16px;
    }
    .add-to-trolley-main .xs-4--none {
      padding-right: 1em;
    }
    .add-to-trolley-main {
      padding-top: 20px;
    }
    th,
    td {
      font-family: ${props => props.theme.font.family.base};
    }
  }

  .pdp-main {
    font-family: ${props => props.theme.font.family.base};
    font-display: swap;
    font-weight: ${props => props.theme.font.weight.regular};
    line-height: 1.5rem;
    color: ${props => props.theme.color.monochrome.darker};
  }
  .pdp-core {
    width: 100%;
    padding-bottom: 1em;
  }
  .pdp-core,
  .pdp-content {
    float: left;
    clear: left;
  }
  .pdp-right {
    @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
      float: right;
      clear: right;
      width: 100%;
    }
  }
  .pdp-core,
  .pdp-right {
    background-color: ${props => props.theme.color.monochrome.white};
    @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
      padding: 20px;
      margin: 15px 0;
    }
  }
  .pdp-content {
    @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
      padding-right: 30px;
    }
  }

  /* Override Fable stylesheet styles to default values */

  *,
  :after,
  :before {
    border-color: unset;
  }

  body {
    line-height: 1;
  }

  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  audio,
  canvas,
  embed,
  iframe,
  img,
  object,
  svg,
  video {
    vertical-align: baseline;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    line-height: normal;
  }

  // Overrides for PinchZoom component
  div .react-transform-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    transform: unset;
    pointer-events: none;
    inset: 0;

    > * {
      pointer-events: auto;
    }
  }
`}
`

export default GlobalStyle
